import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Holiday } from '@/types';
import { useGetHolidaysQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchHolidays<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Holiday> } & Omit<
  AutocompleteProps<Holiday, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetHolidaysQueryProps = useAsyncSearch<Holiday, Multiple, DisableClearable, FreeSolo>(
    useGetHolidaysQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetHolidaysQueryProps} />;
}

export default SearchHolidays;
